import Slider from 'react-slick';
import { useRef } from 'react';
import React from 'react';
import style from './componentCss/Slidebar.module.css';

const Slidebar = ({ title, children }) => {
    const isDragging = useRef(false);
    const dragStartX = useRef(0);
    const dragThreshold = 10; // px to consider as drag

    const handleMouseDown = (e) => {
        isDragging.current = false;
        dragStartX.current = e.clientX;
    };

    const handleMouseMove = (e) => {
        if (Math.abs(e.clientX - dragStartX.current) > dragThreshold) {
            isDragging.current = true;
        }
    };

    const handleClick = (e) => {
        if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
            isDragging.current = false;
        }
    };

    // Ajout du margin-right pour l'espace entre les cards
    const wrappedChildren = React.Children.map(children, (child, i) => (
        <div
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onClick={handleClick}
            className={style.slide}
        >
            {child}
        </div>
    ));

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    infinite: false,
                },
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                    infinite: false,
                    centerMode: false,
                },
            },
        ],
    };

    return (
        <div className={style.container}>
            <div></div>
            {title && (
                <>
                    <h2 className={style.sectionTitle}>{title}</h2>
                    <div className={style.sectionBar}></div>
                </>
            )}
            <Slider className={style.slider} {...settings}>
                {wrappedChildren}
            </Slider>
        </div>
    );
};

export default Slidebar;
